<template>
  <div id="app">
    <app-nav v-if="$store.state.user"></app-nav>
    <router-view></router-view>
    <cc-profile></cc-profile>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import Profile from "./views/Profile";
import Socket from "./mixins/Socket";

export default {
  mixins: [Socket],
  components: {
    'app-nav': Nav,
    'cc-profile': Profile,
  },
  data: function () {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  methods: {
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
      if (this.updateExists) {
        this.$swal({
          title: 'New Version',
          text: 'Phonenet have been updated to new version, please confirm to update!',
          icon: "success",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.refreshApp();
          }
        });
      }
    },
  },

  mounted() {
    document.addEventListener(
        'swUpdated', this.showRefreshUI, {once: true}
    );
    // navigator.serviceWorker is only defined in secure contexts
    // (HTTPS or localhost). LAN access via http://192.168.x.x has no SW.
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener(
          'controllerchange', () => {
            if (this.refreshing)
              return;
            this.refreshing = true;
            window.location.reload();
          }
      );
    }
  }
};
</script>

<style lang="scss">
@import './assets/sass/main';
</style>
























